<div class="form-container">
  <mat-accordion multi displayMode="flat" togglePosition="after">
    <ng-template sectionAnchor></ng-template>
  </mat-accordion>
</div>
